// export const ip = '172.16.10.37';

const ip = '172.16.4.125';

// export const port = '8081';

const port = '18082';

export const localUrl = `http://${ip}:${port}/api`;

export const environment = {
  production: false
};
